<template>
  <div>
    <div class="row">
      <div class="col-lg-12">
        <div class="alert alert-info">
          <strong>Info:</strong> Préciser dans le champ le montant pour exécuter le virement <strong>{{ getCreditLabel }} => Acheteur</strong>
        </div>
        <div class="col-lg-12 text-center">
          <div class="form-group row">
            <label class="col-lg-2 col-form-label">Montant</label>
            <div class="col-lg-12">
              <input
                  id="new-price"
                  name="newPrice"
                  type="number"
                  pattern="[0-9]*"
                  v-model="newPrice"
                  class="select-new-price text-center form-control"
                  @blur="valid"
              >
            </div>
          </div>
        </div>
        <div class="col-lg-12 text-center btnp2p">
          <button v-if="validPrice === true" type="button" class="btn btn-w-m btn-primary" :class="this.valid === false ? 'disabled' : ''" @click.prevent.stop="confirm('credit')">
            {{ getPaymentLabel }}
          </button>
          <button v-else type="button" class="btn btn-w-m btn-primary" :class="this.valid === false ? 'disabled' : ''" @click="onSubmit">
            {{ getPaymentLabel }}
          </button>
          <br>
        </div>
        <div class="col-lg-12">
          <table class="table table-striped" v-if="transferHistory.transfers">
            <thead>
              <tr>
                <th>Date</th>
                <th>User</th>
                <th>Action</th>
                <th>Status</th>
                <th></th>
                <th>Commentaire</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="list in transferHistory.transfers" v-if="list.type !== 2 && list.type !== 1">
                <td>
                  {{ list.date }}
                </td>
                <td>
                  {{ list["user"] }}
                </td>
                <td>
                  {{ list["action"] }}
                </td>
                <td class="btn-lmd">
                  <button v-if="list['status'] === 1" type="button" class="btn btn-w-m btn-primary"><i class="fa fa-check"></i><span class="bold">Complet</span> </button>
                  <button v-else type="button" class="btn btn-w-m btn-danger"><i class="fa fa-times"></i><span class="bold">Exécution a échoué</span> </button>
                </td>
                <td>
                </td>
                <td>
                  <p class="small">
                    {{ list["comment"] }}
                  </p>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import gql from "graphql-tag";
import TransferHistoryList from '../../../api/query/TransferHistoryList.gql'
import store from '../../../config/store'
import { paymentMode } from '@/helpers/utils/constants'

export default {
  props: {
    orderId: {
      type: String,
    },
    customerId: {
      type: String,
    },
    paymentMode: {
      type: Number,
    },
    statuBuyer: {
      type: [String, Number],
      default: ""
    },
    status: {
      type: [String, Number,Object],
      default: ""
    }
  },
  data: () => ({
    store,
    transferHistory: [],
    queries: [],
    newPrice: "",
    timer: 1000,
    hiddenElements: {
      fast: true,
      secure: true,
      care: true
    },
    reloadWallet: false,
    isValid: false,
    priceDisabled: true,
    priceModalDisabled: false,
  }),
  computed: {
    transferMoneyFromCreditMutation () {
      return gql`
          mutation {
            transferMoneyFromCredit(orderId: ${this.orderId}, amount: ${this.newPrice})
            {
              date
              user
              action
              comment
              status
              amount
              walletSeller
              walletBuyer
              transferType
            }
          }`
    },
    display() {
      return (element) => {
        return !this.hiddenElements[element]
      }
    },
    valid () {
      this.isValid = false
      if(this.newPrice !== "") this.isValid = true
      return this.isValid
    },
    validPrice () {
      let value = false
      if (this.newPrice > 0)
        if (this.newPrice < 3000) value = true
      return value
    },
    getPaymentLabel () {
      switch (this.paymentMode) {
        case paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE:
          return 'Executer virements P2P DIAC'
        case paymentMode.CREDIT_PAYMENT_MODE_COFIDIS:
          return 'Executer virements P2P Cofidis'
        case paymentMode.CREDIT_PAYMENT_MODE_YOUNITED:
          return 'Executer virements P2P Younited'
        default:
          return ''
      }
    },
    getCreditLabel () {
      switch (this.paymentMode) {
        case paymentMode.CREDIT_PAYMENT_MODE_MOBILIZE:
          return 'DIAC'
        case paymentMode.CREDIT_PAYMENT_MODE_COFIDIS:
          return 'Cofidis'
        case paymentMode.CREDIT_PAYMENT_MODE_YOUNITED:
          return 'Younited'
        default:
          return ''
      }
    },
  },
  async mounted () {
    await this.$bus.$on('diac-confirm-success', this.onConfirmAlert)
  },
  methods: {
    confirm (type) {
      let content = '';
      let title = '';
      if (type === 'credit') {
        content = `Confirmer le virement de ${this.newPrice}€?`;
        title = 'Êtes-vous sûr ?';
      }
      this.showModal({
        childVue: 'confirm',
        dataModel: {
          title: title,
          content,
          type
        }
      })
    },
    displayElement(element) {
      this.hiddenElements[element] = false
    },
    async onSubmit () {
      let result = await this.$validator.validateAll()

      if (this.newPrice > 75000 ) {
        this.showBanner('danger', `Le montant maximal est de 75 000 €`)
        return
      }else if (this.newPrice <= 0 ) {
        this.showBanner('danger', `Le montant doit être supérieur à 0`)
        return
      } else {
        if (result) {
          this.$apollo.mutate({
            mutation: this.transferMoneyFromCreditMutation
          }).then(() => {
            setTimeout(function () {
              if (this.$route.name === 'command-details-credit') this.$router.push({name: 'command-details-lemonway-b'})
              else this.$router.push({name: 'command-details-credit'})
              //location.reload(true)
            }, 500)
            this.showBanner('success', 'le virement est terminé')
          })
        }

      }
    },
    async onConfirmAlert () {
      let result = await this.$validator.validateAll()
      if (result) {
        this.$apollo.mutate({
          mutation: this.transferMoneyFromCreditMutation
        }).then(() => {
          setTimeout(function () {
            if (this.$route.name === 'command-details-credit') this.$router.push({name: 'command-details-lemonway-b'})
            else this.$router.push({name: 'command-details-credit'})
            //location.reload(true)
          }, 500)
          this.showBanner('success', 'le virement est terminé')
        })
      }
    }
  },
  apollo: {
    transferHistory: {
      query: TransferHistoryList,
      variables() {
        return {
          orderId: this.orderId
        }
      },
    }
  }
}
</script>
